import React from "react";

import "./nps-zone-of-excellence.css";

export default function NpsZoneOfExcellence({
  zones = [
    { color: "#008908", text: "Zona de excelência (76 e 100)" },
    { color: "#F2BD00", text: "Zona de qualidade (51 e 75)" },
    { color: "#F4511E", text: "Zona de aperfeiçoamento (1 e 50)" },
    { color: "#C90000", text: "Zona crítica (-100 e 0)" },
  ],
}) {
  const hasZones = !!zones && zones.length > 0;
  return (
    <ul className="nps-zone-of-excellence">
      {hasZones &&
        zones.map((zone, index) => {
          return (
            <li key={index} className="nps-zone-of-excellence__zone">
              <div
                className="nps-zone-of-excellence__zone__icon"
                style={{ backgroundColor: zone.color }}
              ></div>
              <p className="nps-zone-of-excellence__zone__text">{zone.text}</p>
            </li>
          );
        })}
    </ul>
  );
}
